import React from 'react';
import { useConfig } from '@dotone/react-ui-core/hooks';
import { useTranslate } from '@hooks';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { NextLink } from '@dotone/react-ui-core';

const UserLoginTabNav = ({ active }) => {
  const { t } = useTranslate('login', 'tabs');
  const { test } = useConfig();

  return (
    <Nav pills>
      <NavItem style={{ width: '50%' }}>
        <NavLink
          active={active === 'network'}
          href={active === 'network' ? '' : '/advertisers/login'}
          tag={NextLink}
        >
          {t('network')}
        </NavLink>
      </NavItem>
      {!!test && (
        <NavItem style={{ width: '50%' }}>
          <NavLink
            active={active === 'member'}
            href={active === 'member' ? '' : '/advertisers/users/login'}
            tag={NextLink}
          >
            {t('member')}
          </NavLink>
        </NavItem>
      )}
    </Nav>
  );
};

export default UserLoginTabNav;
